export default "__VITE_ASSET__DH6eeYaV__"